import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {UserService} from "../../../services/user.service";
import {Localiser} from "../../../services/localiser";

@Component({
  selector: 'app-configure',
  templateUrl: './configure.component.html',
  styleUrls: ['./configure.component.css']
})
export class ConfigureComponent implements OnInit {

  factors = {
    luminariaConsumoPorHora: 0,
    // https://www.epa.gov/energy/greenhouse-gases-equivalencies-calculator-calculations-and-references#kilowatt
    kwhToReducedTonCO2: 0,
    kwhToConsumedTonCO2: 0,
    co2ToKilometer: 0,
    co2ToHouse: 0,
    co2ToTree: 0,
    co2ToPhone: 0
  }

  constructor(public dialogRef: MatDialogRef<ConfigureComponent>,
              @Inject(MAT_DIALOG_DATA) public data: {factors},
              public localiser: Localiser) { }

  ngOnInit(): void {
    console.log(this.data)
    this.factors = this.data.factors;
    console.log(this.factors)
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    this.dialogRef.close({factors: this.factors});
  }

}
